module.exports = __webpack_public_path__ + "static/media/default-template-big.7180606b.jpg";